import { render, staticRenderFns } from "./TeamDetailsCard.vue?vue&type=template&id=d46a2a6c&scoped=true&"
import script from "./TeamDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./TeamDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamDetailsCard.vue?vue&type=style&index=0&id=d46a2a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46a2a6c",
  null
  
)

export default component.exports